import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'

import {
  MenuContainer,
  DetailsSection,
  Price,
  Description,
  Divider,
  InnerContainer,
  Name,
  NameCont,
  PromoIcon,
} from './styled'
import VenueGenericImage from 'components.v2/VenueGenericImage'
import asset from 'utils/asset'

class MenuItem extends React.PureComponent {
  pickMenu = () => {
    this.props.openModal(this.props.menu)
  }

  render() {
    const { orders, menu } = this.props
    const { id, name, description, photo, price } = menu
    const isActive = orders.includes(id)
    return (
      <MenuContainer isActive={isActive} onClick={this.pickMenu}>
        <InnerContainer>
          <DetailsSection>
            <NameCont>
              {get(menu, 'has_diamond_loyalty') === '1' ? (
                <PromoIcon
                  src={asset('images/icons/diamond.svg')}
                  alt="Diamond Loyalty"
                />
              ) : get(menu, 'has_emerald_loyalty') === '1' ? (
                <PromoIcon
                  src={asset('images/icons/emerald.svg')}
                  alt="Emerald Loyalty"
                />
              ) : (
                <div />
              )}
              <Name>{name}</Name>
            </NameCont>
            {description && <Description>{description}</Description>}
            <Price light>{price}</Price>
          </DetailsSection>
          {photo && (
            <VenueGenericImage
              image={photo}
              name={name}
              dimensions={{
                image: { width: 200, height: 200 },
                style: { width: 88, height: 88 },
              }}
            />
          )}
        </InnerContainer>
        <Divider />
      </MenuContainer>
    )
  }
}

MenuItem.propTypes = {
  orders: PropTypes.array,
  menu: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
}

export default MenuItem
